// Film-frame glyph — a rounded frame with three sprocket holes down each edge
// and a clear centre. Drawn in currentColor so callers set the colour via CSS
// (header renders it at 20px in var(--accent); empty states at ~96px dim).

export function Logo({ size = 20 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden
      style={{ display: "block", flexShrink: 0 }}
    >
      <rect x="2" y="2" width="20" height="20" rx="4" stroke="currentColor" strokeWidth="2" />
      <rect x="5.2" y="5.6" width="2.8" height="2.8" rx="0.7" fill="currentColor" />
      <rect x="5.2" y="10.6" width="2.8" height="2.8" rx="0.7" fill="currentColor" />
      <rect x="5.2" y="15.6" width="2.8" height="2.8" rx="0.7" fill="currentColor" />
      <rect x="16" y="5.6" width="2.8" height="2.8" rx="0.7" fill="currentColor" />
      <rect x="16" y="10.6" width="2.8" height="2.8" rx="0.7" fill="currentColor" />
      <rect x="16" y="15.6" width="2.8" height="2.8" rx="0.7" fill="currentColor" />
    </svg>
  );
}
